export default function removeEmptyChildren(obj: any): any {
  // Keep behavior deterministic by working on a deep-cloned value.
  const deepClone = (value: any): any => JSON.parse(JSON.stringify(value));

  const removeEmpty = (value: any): any => {
    if (Array.isArray(value)) {
      return value.map((item) => {
        if (item?.children && Array.isArray(item.children) && item.children.length === 0) {
          const { children, ...rest } = item;
          return rest;
        }

        return removeEmpty(item);
      });
    }

    if (typeof value === "object" && value !== null) {
      const result: any = {};

      for (const key in value) {
        if (!Object.prototype.hasOwnProperty.call(value, key)) {
          continue;
        }

        if (key === "children" && Array.isArray(value[key]) && value[key].length === 0) {
          continue;
        }

        result[key] = removeEmpty(value[key]);
      }

      return result;
    }

    return value;
  };

  return removeEmpty(deepClone(obj));
}